import styled from 'styled-components'

export const HEADER_HEIGHT = '5rem'
const NAVIGATION_BG = '#EAE9EF'

export const StyledMain = styled.div`
  width: 100%;
`

export const MainHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${props => props.theme.colors.white[500]};
  height: ${HEADER_HEIGHT};
  padding-inline: ${props => props.theme.spacing.xlarge};

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    padding-inline: ${props => props.theme.spacing.medium};
  }
`

export const MainNavigationWrapper = styled.div`
  background-color: ${NAVIGATION_BG};
  padding-inline: ${props => props.theme.spacing.xlarge};
`

export const MainNavigationInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 4rem;
  background-color: ${NAVIGATION_BG};

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    display: none;
  }
`

export const MainWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-block: ${props => props.theme.spacing.xlarge};

  @media screen and (max-width: 70rem) {
    padding-inline: ${props => props.theme.spacing.xlarge};
  }

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    flex-direction: column;
    padding: ${props => props.theme.spacing.medium};
  }
`

export const MainContent = styled.div`
  width: 100%;
`

export const PageTitle = styled.div`
  display: none;
  font-size: ${props => props.theme.font.medium};
  font-weight: ${props => props.theme.fontWeight.medium};
  margin-bottom: ${props => props.theme.spacing.large};

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    display: block;
  }
`

export const CompanyTitleWrapper = styled.div`
  white-space: nowrap;
  color: #7b7b7b;
`
